import {
  Avatar,
  ColumnDefinition,
  NeutralTag,
  SuccessTag,
} from "@certn/cascadia-react";
import { Text } from "@certn/cascadia";
import { formatDate, parseName } from "@certn/utils";
import { TFunction } from "i18next";
import compact from "lodash/compact";
import { ReactNode } from "react";
interface CommonTemplateFields {
  id: string;
  name: string;
  is_active: boolean;
  usage_count: number;
  created: string;
  created_by?: { auth0_full_name?: string | null } | null;
}

export const getCommonTableColumns = <T extends CommonTemplateFields>(input: {
  actions: ({ row }: { row: T }) => ReactNode;
  translate: TFunction<"translation", undefined, "translation">;
  hideActions?: boolean;
}): ColumnDefinition<T>[] => {
  const { actions, translate, hideActions = false } = input;

  return compact([
    {
      key: "name",
      name: translate("Name"),
      isRowHeader: true,
      testID: "name-column-header",
      render({ name }) {
        return (
          <Text style="form/body-secondary" testID="template-name">
            {name}
          </Text>
        );
      },
    },
    {
      key: "is_active",
      name: translate("Status"),
      isRowHeader: true,
      testID: "status-column-header",
      render({ is_active }) {
        return (
          <Text style="form/body-secondary" testID="template-status">
            {is_active ? (
              <SuccessTag testID="active-tag" type="subtle">
                {translate("Active")}
              </SuccessTag>
            ) : (
              <NeutralTag type="subtle" testID="inactive-tag">
                {translate("Inactive")}
              </NeutralTag>
            )}
          </Text>
        );
      },
    },
    {
      key: "usage_count",
      name: translate("Usage"),
      isRowHeader: true,
      testID: "usage-count-column-header",
      render({ usage_count }) {
        return (
          <Text style="form/body-secondary" testID="template-usage-count">
            {`${usage_count} ${translate("cases")}`}
          </Text>
        );
      },
    },
    {
      key: "created",
      name: translate("Created date"),
      isRowHeader: true,
      allowsSorting: true,
      testID: "created-date-column-header",
      render({ created }) {
        return (
          <Text style="form/body-secondary" testID="template-usage-count">
            {formatDate(created, "MMM dd, yyyy")}
          </Text>
        );
      },
    },
    {
      key: "created-by",
      name: translate("Created by"),
      isRowHeader: true,
      testID: "created-by-column-header",
      render({ created_by }) {
        if (created_by) {
          return (
            <Avatar
              size="small"
              name={parseName(created_by.auth0_full_name || undefined)}
            />
          );
        }
      },
    },
    hideActions
      ? undefined
      : {
          key: "actions",
          isAction: true,
          width: 48,
          render(row) {
            return actions({ row });
          },
        },
  ]);
};
